import { Map } from "@outdoormap/gatsby-plugin-brand-sites"

export default Map
